<template>
    <div class=" fadeInDown animated"   style="visibility: visible; animation-name: fadeInDown;">
        <div class="clearfix" ></div>
      <el-segmented v-model="value" :options="options"  size="large" />
      <div class="clearfix" ></div>
      <br>
      <el-row :gutter="20">
        <el-col :span="4"><div class="grid-content ep-bg-purple parent" >
            <el-icon  class="child"  color="red" size="50px" @click="slideDirection = -1"><ArrowLeft /></el-icon></div></el-col>
         <el-col :span="16" ref="scrollContainer"    
            style="overflow: hidden;   display: grid;
            grid-auto-flow: column; /* 使子元素横排 */
            gap: 10px; /* 可选，用于设置元素之间的间距 */  height: fit-content;" >
            <div class="grid-content ep-bg-purple box"   v-for="item in list" :key="item" 
            :style="{ transform: `translateX(${slidePosition}px)`,height: height}"
            style=" width: 400px;  padding: 10px; display: inline-block ;transition-duration:1000ms; visibility: visible; animation-name: fadeInUp;">
            <el-image class=" fadeInUp animated"    :src="item"></el-image> 
           </div>
          </el-col>
        <el-col :span="4"><div class="grid-content ep-bg-purple parent" ><el-icon  @click="slideDirection = 1" class="child" color="red" size="50px"><ArrowRight /></el-icon></div></el-col>
      </el-row>
    </div>
  </template>
 
<script>
import { ref, onMounted, watch } from 'vue';
    export default {
    setup() {
        const list= ref(["images/rongyu/ry4.jpg" ,
        "images/rongyu/ry5.jpg" , "images/rongyu/ry6.jpg" ,
        "images/rongyu/ry1.jpg" , "images/rongyu/ry2.jpg" ,
        "images/rongyu/ry3.jpg" , 
       ])
       const  listjl= ref(["images/ry/2021年五一劳动奖状 (2).jpg" ,
        "images/ry/五一劳动奖状证书2021年.jpg","images/ry/ry11.jpg"
       ])
       const  listry=ref(["images/rongyu/ry4.jpg" ,
        "images/rongyu/ry5.jpg" , "images/rongyu/ry6.jpg" ,
        "images/rongyu/ry1.jpg" , "images/rongyu/ry2.jpg" ,
        "images/rongyu/ry3.jpg" , 
       ])
        var height=ref('550px');
        const scrollContainer = ref(null);
        const value = ref('荣誉')
        const options = [
        '奖励',
        '荣誉'
        ]
        // 可以在这里添加其他逻辑，比如使用 onMounted 钩子来初始化某些数据
        onMounted(() => {
        // 例如，可以在这里做一些额外的 DOM 操作或数据获取
        });
        const slidePosition = ref(0);
        const slideDirection = ref(0);
    
        const slideElement = () => {
        if (slideDirection.value !== 0) {
            slidePosition.value += slideDirection.value * 600; // 每次滑动200px
    
            // 重置方向，以便下次点击时不会连续滑动
            setTimeout(() => {
            slideDirection.value = 0;
            }, 500); // 假设动画持续时间为500ms
        }
        };
        // 监听 slidePosition 的变化，并在变化时触发滑动动画
        watch(slideDirection, () => {
        slideElement();
        }, { immediate: true });
             // 监听 slidePosition 的变化，并在变化时触发滑动动画
        watch(value, () => {
     
           if(value.value== '奖励') {
              height.value='550px'
              list.value=listjl.value
           }else {
              height.value='fit-content'
              list.value=listry.value
           }
        }, { immediate: true });

        return {
        scrollContainer,
        list,
        options,
        value,
        slidePosition,
        slideDirection,
        height
        };
    },
    };
</script>


  <style  scoped>
  .el-segmented {
       
        --el-segmented-item-selected-bg-color: #ff0000;
    }
 .box {
    width: 100%;
    border: 1px solid #bdbdbd;
    position: relative;
    background: #fff;
}
.parent {
   display: flex;
   justify-content: center; /* 水平居中 */
   align-items: center;    /* 垂直居中 */
   position: relative;
   align-items: center;
   height: 100%;
}
.child {
  position: absolute;
   margin: 50%;

}
  </style>
  